import styled from 'styled-components';

export const Errors = styled.div`
  font-size: 14px;
  text-align: center;
  margin-bottom: 16px;
  color: ${props => props.theme.colors.red};
`;

export const Header = styled.div`
  font-size: 18px;
  line-height: 28px;
  font-weight: 700;
  margin-bottom: 8px;
  text-align: center;
`;

export const SubHeader = styled.div`
  text-align: center;
  margin-bottom: 32px;
`;
